module.exports = __webpack_public_path__ + "assets/img/support.a97402bf.jpg";